var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('embeddable-footer',{attrs:{"sharing-options-values":{title: _vm.socialTitle},"lead":_vm.leadApp,"title":_vm.titleApp,"home-url":_vm.urlApp}})}
var staticRenderFns = []

export { render, staticRenderFns }